common.View.create('canvas.blocks.custom.slider.Block', {

    onDOMLoad() {
        this.initSlider();
    },

    initSlider() {

        this.element.find('.owl-carousel').owlCarousel({
            loop: true,
            margin: 0,
            items: 1,
            nav: true,
        });

        /*
                // Listen for changed slides.
                .on('changed.owl.carousel', () => this.removeCanvasDataFromClonedSlides())

            	// Disable canvas selection on buttons.
                .find('.owl-nav, .owl-dots')
                    .attr('data-canvas-selectable', false)
                    .end();

        //
        this.removeCanvasDataFromClonedSlides();
        */
    },

    removeCanvasDataFromClonedSlides()
    {
        /*
        console.info('removeCanvasDataFromClonedSlides()');

        // Remove Vue editor components from cloned slides.
        this.element

            .find('.owl-carousel .owl-item.cloned > .canvas-selectable')
                .removeAttr('data-vue-component')
                .removeAttr('data-canvas-editable')

                // Loop each slide.
                .each((index, element) =>
                {
                    let loopEditorInstance = $(element).data('vue-instance')

                    if (loopEditorInstance)
                        loopEditorInstance.$destroy();
                });
                */
    },

});
